import { useAuth } from "@/hooks/useAuth";

export type AuthStatus = "initializing" | "authenticated" | "guest";

/**
 * Loading-aware wrapper around `useAuth`.
 *
 * Rule: while auth is initializing, BOTH `isAuthed` and `isGuest` are `false`.
 * UI should render an auth-neutral placeholder during that window — never
 * guess a variant and swap later, which causes flashes (e.g. guest CTAs
 * appearing for an authenticated user on hard refresh / slow networks).
 */
export function useAuthState() {
  const auth = useAuth();
  const { user, loading } = auth;
  const status: AuthStatus = loading ? "initializing" : user ? "authenticated" : "guest";
  return {
    ...auth,
    status,
    isInitializing: status === "initializing",
    isAuthed: status === "authenticated",
    isGuest: status === "guest",
  };
}
